<template>
  <div id="loading-screen">


    <div class="loader">
      <div class="loader-bg">
        <span>Laden</span>
      </div>
      <div class="drops">
        <div class="drop1"></div>
        <div class="drop2"></div>
      </div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
      <defs>
        <filter id="liquid">
          <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="liquid" />
        </filter>
      </defs>
    </svg>


  </div>
</template>

<script>
export default {
  name: "VlLoadingScreen"
}
</script>

<style>
#loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgb(248, 249, 249)
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes drop {
  0% {
    bottom: 0px;
    opacity: 1;
  }

  80% {
    opacity: 1;
  }

  100% {
    opacity: 1;
    bottom: -200px;
  }
}

@keyframes wave {
  0% {
    background-position: 0 160px;
    background-size: 170px 300px;
  }

  100% {
    background-position: 500px -18px;
    background-size: 250px 150px;
  }
}

.loader {
  width: 120px;
  height: 120px;
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  line-height: 120px;
  font-family: sans-serif;
  color: #ffffff;
  font-size: 16px;
}

.loader span {
  z-index: 3;
}

.loader-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: transparent repeat-x 0 100px/150px 300px url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAEsCAYAAACG+vy+AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAYLSURBVHhe7dtNiyR3HcDx6o0m0fiAD4jGh4toEAIh6EUk60E9eRI8+z6SeFXfhyB48AV48TKnYEwiihCU9SFBiItuQBNxEzPtr6d7iZPsfo3L7GzPzOdz2Kr6z7C71VXfrqruqtUC/6/HD364m9taLfeuLi1f2C293Xq5vj5cnt8tLcsPLn9nN7f3BMJxs/PPzv6Z2TM+OTv2h9fr5f0zfffupydtPf/OG6vV8s+Zf33m/zwjL09ML+xLRAK5iDZHgNXy3gnhc7NDPjgjD0wI9838pe0v7JHV8u+jgFbL1fk/XlkOl6unGY9ALoonDn4yQXxp3p0/PiHctxs9q9azLtdn77026/LirNNv71Q0AjmvNqdK9yyPzA702dmBHtiNnmebaF6dPfqP6zeW504qGIGcI6snD342k4fnVOSje3m6dLo2wWxOzV6cYJ6+3WAEctY9efDT2YhfnqPEB3Yj3MxqOZxgrs7r9Ozy/cvf3I3+TwI5ix4/+NGcPj0274yfmiXb8DZMLK/M5Jfr711+bDtyc17cs2SOFvPnV5fD5f7tACdhYvnHTJ6eWL62HXmTQM6AubZ4aq4rvjjXFe/aDXGHTCzX5rU+mNOwbx0tH42yl1bfPfjNnEZtvqG2nU7b5vuXS8vzq3l32hxefn6zwwt3x4TxwoTx6d0id9FqLvjWu/nN4eXlmTwzsXxjO8KpeeLgx6vV8vX14fKR3Qh74Fgg/21ieXUmz80G+8O+3BdzLm0/pv3KvM7v242wR24ZyDGr5foE89JsxF/Mxcu3d6Pcrs3R4tLRx7SfmCXXF3vsnQXyFkdHl9Xyp9nAzzi6vEPbWz8enTeZh5Y7d3csJ+y2AnmLG1/p/2U2/q9ufDzGePMGwc2t4z6iPYNOIpC3Wy2vzwXntZm7MjvHlQtzlNk+S/H5mXto1vuDM3X6dMbdmUBuZntf/99nurkf5vfzjvq3Mx/O9lri0VmXB2edNnfMCuKcOb1AbmW1vDbhvDLTl2ZHe212tF8fje9TPDeODNun7D60Xi/vmelFv1v2Qrj7gbQbj2Ren/nNAzJ/nem/jn5wuPxufrp5VPO4CmvzJN1x98yF88O7+Y175+/82Ezvnwg2864bLrh9DwTuKqcJEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCt7Qs/wE3PQXiXsD0ywAAAABJRU5ErkJggg==');
  z-index: 2;
  background-position: 500px -18px;
  background-size: 250px 150px;
  border-radius: 4px;
  background-color: rgb(0, 121, 194);
  /*animation: wave 1s ease-out forwards;*/
}

.drops {
  -webkit-filter: url('#liquid');
  filter: url('#liquid');
  position:absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
  z-index: 1;
  opacity: 0;
  animation: fade-in .1s linear .4s forwards;
}

.drop1 , .drop2 {
  width: 21px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgb(0, 121, 194);
}

.drop1 {
  width: 90px;
  height: 16px;
  bottom: 2px;
  border-radius: 0;
}

.drop2 {
  animation: drop 1.3s cubic-bezier(1,.19,.66,.12) .5s infinite;
}
</style>
